import * as Axios from 'axios';
import BaseService from '../common/BaseService';
import store from '@/store';
import {
    IBankWatchDashboardSummary,
    IBankWatchUserDetail,
    IBroker
} from '@/domain/bankwatch';

// Client for the pc-admin-server BankWatch dashboard API, mounted under
// /bankwatch/dashboard. The broker drill-down reuses the existing
// /bankwatch/broker-groups/:groupId/brokers endpoint.
export default class BankWatchDashboardService extends BaseService {

    private authHeader() {
        return { Authorization: `Bearer ${store.state.$auth.token}` };
    }

    public async getSummary(selectedMonth: string): Promise<IBankWatchDashboardSummary> {
        const apiConfig: Axios.AxiosRequestConfig = {
            method: 'get',
            url: `${store.state.apiBase}/bankwatch/dashboard/summary`,
            headers: this.authHeader(),
            params: { selectedMonth }
        };
        const res: Axios.AxiosResponse = await this.makeAxiosCall(apiConfig);
        return res.data as IBankWatchDashboardSummary;
    }

    public async getUserDetail(userId: string): Promise<IBankWatchUserDetail> {
        const apiConfig: Axios.AxiosRequestConfig = {
            method: 'get',
            url: `${store.state.apiBase}/bankwatch/dashboard/user-detail`,
            headers: this.authHeader(),
            params: { userId }
        };
        const res: Axios.AxiosResponse = await this.makeAxiosCall(apiConfig);
        return res.data as IBankWatchUserDetail;
    }

    public async getGroupBrokers(groupId: string): Promise<IBroker[]> {
        const apiConfig: Axios.AxiosRequestConfig = {
            method: 'get',
            url: `${store.state.apiBase}/bankwatch/broker-groups/${groupId}/brokers`,
            headers: this.authHeader()
        };
        const res: Axios.AxiosResponse = await this.makeAxiosCall(apiConfig);
        return res.data as IBroker[];
    }
}
